export * from './ResponsesImageEmptyBox';
